<template>
  <div>
    <div
      v-if="!(pivotData && pivotDataDirty)"
      class="grey--text caption text-center px-6 text-no-wrap"
    >
      Not Available
    </div>
    <div
      v-else
    >
      <currency-input
        v-model="data.projected_chartered_weeks"
        suffix="weeks"
        :precision="1"
        :class="{
          'orange lighten-3': data.projected_chartered_weeks !== pivotData.projected_chartered_weeks
        }"
        hide-details
        dense
        filled
        label="Projected weeks"
        placeholder="Enter"
        class="v-text-field--no-border v-text-field--small v-text-field--light-suffix"
        @input="onProjectionInput"
      />
      <currency-input
        v-model="data.average_weekly_price"
        :suffix="data.currency"
        :precision="0"
        :class="{
          'orange lighten-3': data.average_weekly_price !== pivotData.average_weekly_price
        }"
        hide-details
        dense
        filled
        label="Average weekly"
        placeholder="Enter"
        class="v-text-field--no-border v-text-field--small v-text-field--light-suffix"
        @input="onProjectionInput"
      />
      <currency-input
        v-model="data.yearly_income"
        :suffix="data.currency"
        :precision="0"
        :class="{
          'error lighten-2': !data.yearly_income || Number(data.yearly_income) === 0,
          'orange lighten-3': data.yearly_income !== pivotData.yearly_income
        }"
        hide-details
        dense
        filled
        label="Total"
        placeholder="Enter"
        class="v-text-field--no-border v-text-field--small v-text-field--light-suffix"
        @input="onInput"
      />
      <currency-input
        v-model="data.yearly_expense"
        disabled
        :suffix="data.currency"
        :precision="0"
        :class="{
          'error lighten-2': !data.yearly_expense || Number(data.yearly_expense) === 0,
          'orange lighten-3': data.yearly_expense !== pivotData.yearly_expense
        }"
        hide-details
        label="Yearly Expense"
        dense
        filled
        placeholder="Enter"
        class="v-text-field--no-border v-text-field--small v-text-field--light-suffix"
      />
    </div>
  </div>
</template>

<script>
import CurrencyInput from '@/components/helpers/CurrencyInput'
import Big from 'big.js'

export default {
    name: 'YachtModelCountryTableColumn',
    components: {
      CurrencyInput
    },
    props: {
      pivotData: {
        type: Object,
        default: null
      },
      pivotDataDirty: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        data: {
          currency: null,
          yearly_expense: null,
          yearly_income: null,
          projected_chartered_weeks: null,
          average_weekly_price: null,
          cost_cdr: null,
          income_safety_factor: null
        }
      }
    },
    computed: {
      safetyFactor: {
        get: function () {
          if (!this.data.income_safety_factor) return ''

          return Big(this.data.income_safety_factor).times(100).round(4).toString()
        },
        set: function (value) {
          this.data.income_safety_factor = Big(value).div(100).round(4).toString()
        }
      },
      isDirty() {
        for (let key of Object.keys(this.data)) {
          if (this.data[key] !== this.pivotData[key]) return true
        }
        return false
      }
    },
    watch: {
      pivotDataDirty(pivotDataDirty) {
        if (!pivotDataDirty) return

        this.copyPivotDataDirty(pivotDataDirty)
      }
    },
    mounted() {
      if (this.pivotData && this.pivotDataDirty) this.copyPivotDataDirty(this.pivotDataDirty)
    },
    methods: {
      copyPivotDataDirty(pivotDataDirty) {
        this.data.currency = pivotDataDirty.currency
        this.data.yearly_expense = pivotDataDirty.yearly_expense
        this.data.yearly_income = pivotDataDirty.yearly_income
        this.data.projected_chartered_weeks = pivotDataDirty.projected_chartered_weeks
        this.data.average_weekly_price = pivotDataDirty.average_weekly_price
        this.data.cost_cdr = pivotDataDirty.cost_cdr
        this.data.income_safety_factor = pivotDataDirty.income_safety_factor
      },
      onProjectionInput() {
        const weeks = parseFloat(this.data.projected_chartered_weeks) || 0
        const weeklyPrice = parseFloat(this.data.average_weekly_price) || 0
        if (weeks > 0 && weeklyPrice > 0) {
          this.data.yearly_income = Math.round(weeks * weeklyPrice)
        }
        this.onInput()
      },
      onInput() {
        this.$emit('change', this.isDirty, this.data)
      }
    }
  }
</script>
